import React from "react";

const Popup = ({ message, onClose }) => {
  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('popup')) {
      onClose();
    }
  };

  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div className="popup" onClick={handleOverlayClick}>
      <div className="popup-content" onClick={handleContentClick}>
        <span className="close" onClick={onClose}>
          &times;
        </span>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default Popup;